// Local project recovery is available in the macOS app.
export default function WorkProjectChangesCard() { return null; }
